import React from "react"
import "../styles.css"

const DashboardHeader = () => (
  <div className="dashboard-header">
    <h1>Transactions</h1>
    <div className="dashboard-nav">
      <a href="/dashboard">Dashboard</a>
      <a href="/transactions">Transactions</a>
      <a href="/community-report">Community Report</a>
      <button className="make-payment-btn">Make Payment</button>
    </div>
  </div>
)

const TransactionsScreen = () => (
  <div className="dashboard-container">
    <DashboardHeader />
    <p>This is the Transactions page.</p>
  </div>
)

export default TransactionsScreen
